"use client";
import minify from "@/lib/minify";
import Script from "next/script";

type Props = {
  id: string;
};

const FBPixel = ({ id }: Props) => {
  return (
    <>
      {/* Meta Pixel Script Loader */}
      <Script
        id={`mpxl_loader_${id}`}
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: minify(`
            !function(f,b,e,v,n,t,s){
              if(f.fbq) return;
              n = f.fbq = function(){ n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments) };
              if(!f._fbq) f._fbq = n;
              n.push = n; n.loaded = true; n.version = '2.0';
              n.queue = [];
              t = b.createElement(e); t.async = true;
              t.src = "https://connect.facebook.net/en_US/fbevents.js";
              s = b.getElementsByTagName(e)[0];
              s.parentNode.insertBefore(t,s);
            }(window, document, 'script');

            fbq('consent', 'revoke');
            fbq('init', '${id}');
            fbq('track', 'PageView');
          `),
        }}
      />

      {/* Fallback image for no-JS browsers — optional, can be removed */}
      <noscript>
        <img
          height="1"
          width="1"
          style={{ display: "none" }}
          src={`https://www.facebook.com/tr?id=${id}&ev=PageView&noscript=1`}
        />
      </noscript>
    </>
  );
};

export default FBPixel;
